/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import styled from 'styled-components';
import StyledProps from '../common/theme/AppThemeInterface';

const AuthFormWrapper = styled.form`
  grid-area: form;
  overflow: visible;
  padding-top: 2rem;
  position: relative;
  z-index: 1;
  text-align: center;

  width: 288px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
  @keyframes titleFadeIn {
    0% {
      transform: translateY(-50px);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes errorFadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  input:-webkit-autofill {
    box-shadow: 0 0 0 30px ${({ theme }: StyledProps) => theme.primaryInputBackgroundColor} inset;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    font-size: 16px !important;
    font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  }
  div.auth__title {
    display: table;
    animation-name: titleFadeIn;
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    animation-duration: 1s;
    margin-bottom: 25px;
    width: 400px;
    text-align: left;
  }

  span.auth__title__viasat {
    font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyHeavy};
    text-align: center;
    color: white;
    line-height: 44px;
    font-size: 32px;
    font-weight: bold;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 6px;
    opacity: 1;
    position: relative;
  }

  span.auth__title__insights {
    font-family: ${({ theme }: StyledProps) => theme.viasatFontFamilyRegular};
    text-align: center;
    color: white;
    line-height: 44px;
    font-size: 32px;
    font-weight: 400;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 6px;
  }

  .auth__error {
    color: ${({ theme }: StyledProps) => theme.errorTextColor};
    opacity: 1;
    animation-name: errorFadeIn;
    animation-duration: 0.5s;
    text-align: center;
    margin-bottom: 15px;
  }

  .auth__textfield {
    margin-bottom: 35px;
    width: 280px;
    margin-left: 0px;
    background-color: white;
    border-radius: 4px;
    z-index: 0;
    input {
      padding-right: 12px;
      color: ${({ theme }: StyledProps) => theme.darkTextColor};
      background-color: white;
      height: 52px;
      filter: none;
      width: 280px;
      margin-left: 0px;

      border-radius: 4px;
      padding-left: 42px;
      z-index: 1;
      box-sizing: border-box;
    }
  }
  .input__adornment {
    z-index: 2;
    position: absolute;
    color: ${({ theme }: StyledProps) => theme.darkTextColor};
    left: 10px;
    top: 10px;
    background-color: white;
    height: 52px;
  }
  .auth__form {
    text-align: center;
  }
  .auth__actions {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    align-items: center;
    flex-direction: column;

    .auth__forgot {
      cursor: pointer;
      color: #ffffff;
      font-size: 16px;
      text-decoration: none;
      letter-spacing: -0.08px;
      line-height: 18px;
      text-align: center;
    }
  }
`;

export default AuthFormWrapper;
